import masterDataService from '../service/masterData.service';

export const itemAutocompleteService = (requestBody) => masterDataService.searchItemsForAutocomplete(requestBody);

export const itemAutocompleteRequestBuilder = ({ searchText, selectedValue, pageSize, mode, props }) => {
  const selectedRawValue =
    selectedValue ??
    props?.selectedValue ??
    (props?.value && typeof props.value === 'object' ? props.value.value : null);
  const normalizedSelectedValue =
    selectedRawValue && typeof selectedRawValue === 'object' ? selectedRawValue?.value ?? null : selectedRawValue;
  const normalizedSearchText = String(searchText ?? '').trim();
  const fallbackSearchText = normalizedSearchText || String(normalizedSelectedValue ?? '').trim();

  if (!fallbackSearchText) {
    return null;
  }

  if (mode === 'resolveSelectedValue') {
    return {
      searchText: fallbackSearchText,
      pageSize: 1,
      archive: 'N',
    };
  }

  return {
    searchText: fallbackSearchText,
    pageSize,
    archive: 'N',
  };
};
